__webpack_require__.p = "https://pinkii-website.oss-cn-beijing.aliyuncs.com/";